import Url from 'domurl';

/**
 * @typedef {object} ParamsData
 * @property {string} key
 * @property {string} value
 */

/**
 * Получить урл с параметрами
 * @param {Object} params
 * @param {string} [params.key]
 * @param {string} [params.value]
 * @param {string} [params.path]
 * @param {array<ParamsData>} [params.listParams]
 * @returns {string}
 */
export const getUrlWithParams = (params = {}) => {
  const {
    key = '',
    value = '',
    listParams = [],
    path = '',
  } = params;
  const url = new Url();
  const query = url.query;

  if (Array.isArray(listParams) && listParams.length) {
    listParams.forEach((item) => {
      query[item.key] = item.value;
    });
  } else if (typeof value === 'string' && value.length) {
    query[key] = value;
  }

  if (typeof path === 'string' && !!path.length) {
    url.path = path;
  }

  return url.toString();
};

/**
 * Переход на конкретный url
 * @param {string} url
 */
export const setUrl = (url) => {
  window.location.href = url;
};
